export default "__VITE_ASSET__bt1Sp2Up__"